import { HttpPostRequest } from '@infrastructure/axios/http-post-request';
import { IRequestResetPasswordUseCase, RequestResetPasswordAccepted, RequestResetPasswordPayload } from '../../interfaces';

/**
 * ### Request Reset Password Use Case
 *
 * Use this use case if you want to start the process for change the password.
 *
 * **Flow:**
 * 1. User firstly send this request using its `fiscalId` and `captchaToken`.
 * 2. User will receive a email with a link that include a token, and need to click to be redirected to `/set-new-password?token=`
 * 3. In that page user enter its `currentPassword` and `newPassword`. That use case is handle by `@core/domain/Auth/use-cases/ChangePassword`.
 * 4. After user receive a sucess message from server after submit, the process ends there.
 *
 * @author <pino0071@gmail.com> Jose Aburto
 */
export default class RequestResetPasswordUseCase extends HttpPostRequest<RequestResetPasswordPayload, RequestResetPasswordAccepted> implements IRequestResetPasswordUseCase {
  public async execute(payload: RequestResetPasswordPayload): Promise<RequestResetPasswordAccepted> {
    return (await this.dispatch('/auth/request-reset-password', payload)).data.data;
  }
}
